import React from "react";
import type { MenuProps } from "antd";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../components/ui";
import { MenuItems } from "../../utils/navigation/MenuItems";
import AuthContext from "../../context/AuthContext";

const Navbar = ({ menuCollapsed }: { menuCollapsed: boolean }) => {
  const navigate = useNavigate();
  const { idRole } = React.useContext(AuthContext);

  const onClick: MenuProps["onClick"] = ({ key }) => {
    navigate(key);
  };

  // Only show Users menu item for admins (idRole === 1)
  const filteredMenuItems = React.useMemo(() => {
    return (MenuItems ?? []).filter((item) => {
      if (item?.key === "/user") {
        return idRole === "justin@crystin.com"; // Adjust this value to match your admin role id
      }
      return true;
    });
  }, [idRole]);

  return (
    <>
      <Logo mobile={menuCollapsed} />
      <Menu
        className="pt-2"
        onClick={onClick}
        defaultSelectedKeys={["1"]}
        mode="inline"
        items={filteredMenuItems}
      />
    </>
  );
};

export default Navbar;
